// thai.js泰语文件
export default {
	message: {
		language: 'ภาษา',
		plogin: 'กรุณาเข้าสู่ระบบก่อน!',
		login: 'เข้าสู่ระบบ',
		login1: 'เข้าสู่ระบบตอนนี้',
		logintips: 'สัมผัสประสบการณ์บริการเพิ่มเติมหลังจากเข้าสู่ระบบ',
		register: 'ลงทะเบียน',
		register1: 'ลงทะเบียนตอนนี้',
		loginout: 'ออกจาก',
		join: 'เข้าร่วม',
		days: 'วัน',
		lastip: 'ลงชื่อเข้าใช้ IP ครั้งล่าสุด',
		account: 'หมายเลขบัญชี',
		game: 'เกม',
		video: 'วีดีโอ',
		collect: 'คอลเลกชัน',
		Favorite: 'คอลเลกชัน',
		collect1: 'รายการโปรด',
		share: 'แบ่งปัน',
		sharelive: 'แชร์การถ่ายทอดสด',
		Cache: 'แคช',
		download: 'ดาวน์โหลด',
		wallet: 'กระเป๋าสตางค์',
		recharge: 'เติมเงิน',
		withdraw: 'ถอนเงินสด',
		noble: 'โนเบิล',
		record: 'บันทึก',
		RechargeTime: 'เวลาเติมเงิน',
		WithdrawalTime: 'เวลาถอนเงิน',
		RechargeRecord: 'บันทึกการเติมเงิน',
		WithdrawalRecords: 'บันทึกการถอนเงิน',
		TransactionRecords: 'บันทึกการซื้อขาย',
		business: 'ธุรกิจ',
		message: 'ข้อความ',
		activity: 'ข้อเสนอพิเศษ',
		setting: 'การตั้งค่า',
		help: 'ความช่วยเหลือ',
		version: 'รุ่น',
		loggingout: 'ออกจาก Login',
		remember: 'จำรหัสผ่าน',
		forget: 'ลืมรหัสผ่าน',
		noaccount: 'ไม่มีหมายเลขบัญชี',
		returnhome: 'กลับไปที่หน้าแรก',
		bottomtips: 'กลุ่มนี้ดำเนินการอย่างถูกต้องตามกฎหมายภายใต้การกำกับดูแลของ PAGCOR ประเทศฟิลิปปินส์และ Isle of Man Gaming Association ประเทศอังกฤษ',
		days21: 'มีอายุครบ 21 ปี และได้อ่านและยินยอม',
		rules: 'กฎและข้อกำหนด',
		hadaccount: 'หมายเลขบัญชีที่มีอยู่แล้ว',
		gonggao: 'ประกาศ',
		system: 'ระบบ',
		home: 'หน้าหลัก',
		kefu: 'ฝ่ายบริการลูกค้า',
		kefuCenter: 'ศูนย์บริการลูกค้า',
		mykf1desc: 'กรุณาดาวน์โหลด APP Add ID ด้านล่างเพื่อติดต่อฉัน',
		mykf2desc: 'ดาวน์โหลดที่อยู่',
		mykf3desc1: 'ฝ่ายบริการลูกค้าออนไลน์',
		mykf3desc2: 'คลิกเพื่อเริ่มแชทออนไลน์',
		mykf3desc3: 'การจัดการกับการเติมเงินไม่เข้าบัญชีการถอนเงินเช่นเดียวกับปัญหาเกม',
		my: 'ของฉัน',
		close: 'ปิด',
		zuixin: 'ล่าสุด',
		yhdetail: 'รายละเอียดข้อเสนอ',
		mywallet: 'กระเป๋าสตางค์ของฉัน',
		zichan: 'สินทรัพย์',
		yuan: 'หยวน',
		zxwallet: 'กระเป๋าสตางค์กลาง',
		ptwallet: 'แพลตฟอร์มกระเป๋าสตางค์',
		transfer: 'โอนเงิน',
		LimitTransfer: 'การโอนวงเงิน',
		cards: 'การจัดการซองการ์ด',
		gamebalance: 'ยอดคงเหลือของเกม',
		onerecycle: 'รีไซเคิลได้ด้วยคลิกเดียว',
		Recovery: 'จำนวนการกู้คืน',
		Recycling: 'ในการรีไซเคิล',
		wei: 'วี',
		loading: 'กำลังโหลด',
		refreshing: 'รีเฟรช',
		refreshend: 'รีเฟรชความสำเร็จ',
		success: 'ความสำเร็จในการดำเนินงาน',
		czamount: 'จำนวนเงินที่เติมเงิน',
		limit: 'วงเงิน',
		saccount: 'เลือกบัญชี',
		skbank: 'ธนาคารผู้รับเงิน',
		skname: 'ชื่อผู้รับเงิน',
		copy: 'คัดลอก',
		skcard: 'หมายเลขบัตรรับเงิน',
		submit: 'ส่ง',
		Confirmsubmit: 'ยืนยันการส่ง',
		nextstep: 'ขั้นตอนต่อไป',
		customerservice: 'ฝ่ายบริการลูกค้าประดิษฐ์',
		pleasecontact: 'หากมีข้อสงสัยสามารถติดต่อได้ที่',
		copysuccess: 'คัดลอกไปยังแผ่นตัดเรียบร้อยแล้ว',
		copyfail: 'การคัดลอกล้มเหลว',
		firstmoney: 'กรุณากรอกจำนวนเงินที่เติมเงินก่อน',
		rechargelowtips: 'ยอดเติมเงินต้องไม่น้อยกว่าขั้นต่ำ',
		rechargeuptips: 'การเติมเงินไม่เกินวงเงินสูงสุด',
		firstaccount: 'โปรดเลือกบัญชีก่อน',
		selwallet: 'เลือกกระเป๋าสตางค์',
		firstoutwallet: 'โปรดเลือกโอนออกจากกระเป๋าสตางค์ก่อน',
		retract: 'วางลง',
		expend: 'ขยาย',
		mzmodel: 'โหมดหมุนฟรี',
		mzmodeltips: 'ยอดคงเหลือจะถูกโอนไปยังสถานที่เล่นเกมโดยอัตโนมัติหลังจากเปิด',
		seloutwallet: 'เลือกโอนกระเป๋าสตางค์',
		selinwallet: 'เลือกการโอนเข้ากระเป๋าสตางค์',
		transfertips: 'ไม่สามารถโอนระหว่างกระเป๋าสตางค์ของสถานที่จัดงานได้',
		maxamount: 'จำนวนสูงสุด',
		codings: 'ปริมาณการพิมพ์รหัส',
		washingAmount: 'ปริมาณการล้างรหัส',
		withamount: 'จำนวนเงินถอน',
		banks: 'บัตรธนาคาร',
		withzhtips: 'โปรดผูกบัญชีถอนเงินก่อน',
		withmoneytips: 'กรุณากรอกจำนวนเงินที่ถอนก่อน',
		add: 'เพิ่ม',
		antoken1: 'กระเป๋าสตางค์ออนไลน์ชั้นนำระดับโลกสำหรับเหรียญเสมือนการเติมเงินและถอนเงินสดอัตโนมัติไปยังบัญชีการทำธุรกรรมการโอนเงินได้รวดเร็วและปลอดภัยยิ่งขึ้น',
		antoken2: 'ดาวน์โหลด AnToken Personal Wallet APP: คลิกเพื่อเข้าถึง URL โดยตรง',
		antoken3: 'https://antoken.pro',
		cardtips: 'เคล็ดลับที่อบอุ่น: สามารถผูกได้เพียง 5 ชิ้นต่อบัญชีเช่นถ้าแก้ไขโปรดเพิ่มใหม่หลังจากลบ!',
		walletaddress: 'ที่อยู่กระเป๋าสตางค์',
		walletaddressdesc: 'กรุณากรอกที่อยู่ K Bean สำหรับชุดภาษาอังกฤษ 34 หลักที่ขึ้นต้นด้วย ec',
		USDTaddress: 'ที่อยู่ USDT',
		unbindingtips: 'แน่ใจนะว่าต้องการแก้มัด',
		paypass: 'รหัสผ่านการชำระเงิน',
		cardprotocol: 'ข้อตกลงกระเป๋าสตางค์',
		cardaddress: 'ที่อยู่กระเป๋าสตางค์',
		Cardholder: 'ผู้ถือบัตร',
		bankcard: 'หมายเลขบัตรธนาคาร',
		bankname: 'เปิดบัญชีธนาคาร',
		banknamedesc: 'กรุณาเลือกธนาคารที่เปิดบัญชี',
		bankaddress: 'ที่อยู่เปิดบัญชี',
		bankaddressdesc: 'กรุณาเลือกที่อยู่เปิดบัญชี',
		bankother: 'เปิดบัญชี สาขาย่อย',
		firstpaypass: 'กรุณากรอกรหัสผ่านการชำระเงิน',
		bindtips: 'กรุณากรอกข้อมูลให้ถูกต้องและไม่สามารถแก้ไขได้หลังจากผูกมัด',
		Paymentcode: 'รหัสรับเงิน',
		platname: 'Tenda ความบันเทิง',
		records: 'บันทึกการชาร์จ',
		gameRecord: 'บันทึกเกม',
		betrecord: 'หมายเหตุเกม',
		betDetail: 'รายละเอียดการเดิมพัน',
		accountsetting: 'การตั้งค่าบัญชี',
		messages: 'ข้อความของฉัน',
		returnrecord: 'บันทึกการคืนน้ำ',
		transferrecord: 'บันทึกการโอนเงิน',
		activityrecord: 'บันทึกการสมัครกิจกรรม',
		applyfor: 'ใบสมัคร',
		welfare: 'ซองจดหมายสีแดง',
		query: 'สอบถาม',
		Time: 'เวลา',
		To: 'ถึง',
		dllogin: 'เข้าสู่ระบบตัวแทน',
		outsuccess: 'ออกจากความสำเร็จ',
		today: 'วันนี้',
		days7: 'เกือบ 7 วัน',
		days14: 'เกือบ 14 วัน',
		days30: 'เกือบ 30 วัน',
		cunkuan: 'การฝากเงิน',
		qukuan: 'ถอนเงิน',
		ordersn: 'หมายเลขการสั่งซื้อ',
		money: 'จำนวนเงิน',
		state: 'สถานะ',
		nomore: 'ไม่มีอีกแล้ว',
		More: 'มากกว่า',
		SeeMore: 'ดูเพิ่มเติม',
		Detail: 'ดูรายละเอียด',
		Changebatch: 'เปลี่ยนล็อต',
		Lovely: 'เดาว่าคุณชอบ',
		selplatform: 'เลือกแพลตฟอร์ม',
		betamount: 'จำนวนเงินเดิมพัน',
		betgame: 'เกม',
		betresult: 'ผลการเดิมพัน',
		perfect1: 'ปรับปรุงข้อมูลบัญชีให้ปลอดภัยยิ่งขึ้น',
		perfect2: 'ปรับแต่งโปรไฟล์ของคุณ',
		perfect3: 'ข้อมูลที่สมบูรณ์มากขึ้นและบริการของเรารอบคอบมากขึ้น',
		perfect4: 'ไปสมบูรณ์แบบ',
		binding: 'ผูก',
		AddBinding: 'เพิ่มพันธะ',
		carding1: 'การจัดการบัตร',
		carding2: 'สำหรับการถอนเงินโปรดผูกบัตรธนาคารหรือที่อยู่เหรียญเสมือน',
		logpassword1: 'รหัสผ่านเข้าสู่ระบบ',
		logpassword2: 'แก้ไขรหัสผ่านการเข้าสู่ระบบเป็นประจำการรักษาความปลอดภัยของบัญชีที่ดี',
		paypassword1: 'รหัสผ่านการชำระเงิน',
		paypassword2: 'แก้ไขรหัสผ่านการชำระเงินอย่างสม่ำเสมอเพื่อความปลอดภัยของบัญชีที่ดี',
		oldloginpass: 'รหัสผ่านเข้าสู่ระบบเดิม',
		newloginpass: 'รหัสผ่านเข้าสู่ระบบใหม่',
		oldloginpassdesc: 'โปรดป้อนรหัสผ่านเข้าสู่ระบบเดิม',
		newloginpassdesc: 'กรุณากรอกรหัสผ่านเข้าสู่ระบบใหม่',
		confirmpass: 'ยืนยันรหัสผ่าน',
		confirmpassdesc: 'กรุณากรอกรหัสผ่านเพื่อยืนยัน',
		oldpaypass: 'รหัสผ่านการชำระเงินเดิม',
		newpaypass: 'รหัสผ่านการชำระเงินใหม่',
		oldpaypassdesc: 'กรุณากรอกรหัสผ่านการชำระเงินเดิม',
		newpaypassdesc: 'กรุณากรอกรหัสผ่านการชำระเงินใหม่',
		personalinformation: 'แก้ไขข้อมูล',
		edit: 'บรรณาธิการ',
		SelectAll: 'เลือกทั้งหมด',
		Delete: 'ลบ',
		avatar: 'อัพโหลดรูปโปรไฟล์',
		username: 'ผู้ใช้',
		userID: 'รหัสผู้ใช้',
		userIDdesc: 'กรุณากรอก User ID',
		username1: 'ชื่อผู้ใช้',
		realname: 'ชื่อ-นามสกุล',
		nickname: 'ชื่อเล่น',
		realname2: 'ชื่อจริง',
		realname1: 'ชื่อหรือชื่อเล่น',
		realname1desc: 'กรุณาใส่ชื่อหรือชื่อเล่น',
		realnamedesc: 'กรุณากรอกชื่อ',
		nicknamedesc: 'กรุณากรอกชื่อเล่น',
		sex: 'เพศ',
		birthday: 'วันเกิด',
		birthdaydesc: 'กรุณาเลือกวันเกิด',
		email: 'กล่องจดหมาย',
		phone: 'หมายเลขโทรศัพท์มือถือ',
		nationality: 'สัญชาติ',
		nationalitydesc: 'กรุณาระบุสัญชาติ',
		education: 'วุฒิการศึกษา',
		educationdesc: 'กรุณากรอกวุฒิการศึกษา',
		AnnualSalary: 'เงินเดือนประจำปี',
		AnnualSalarydesc: 'กรุณาระบุเงินเดือนประจำปี',
		work: 'งาน',
		workdesc: 'กรุณากรอกงาน',
		RegistrationTime: 'เวลาลงทะเบียน',
		LastLogin: 'เข้าสู่ระบบล่าสุด',
		operate: 'การดำเนินงาน',
		mail: 'จดหมายภายในสถานี',
		allplat: 'แพลตฟอร์มเต็มรูปแบบ',
		upgrade: 'อัพเกรด',
		draw: 'รับ',
		Received: 'ได้รับแล้ว',
		totaldraw: 'รับรวม',
		undraw: 'รอรับ',
		transin: 'โอนเข้า',
		transout: 'โอนออก',
		transtype: 'เลือกประเภทการซื้อขาย',
		walfareinfo: 'สถานการณ์ซองจดหมายสีแดง',
		help1: 'สวัสดีครับ สมาชิกที่เคารพ',
		help2: 'ยินดีต้อนรับสู่ศูนย์ช่วยเหลือ',
		help3: 'หากปัญหาที่เกี่ยวข้องยังไม่ได้รับการแก้ไขโปรดติดต่อฝ่ายบริการลูกค้าออนไลน์',
		ungot: 'ไม่ผ่านมาตรฐาน',
		got: 'ผ่านมาตรฐานแล้ว',
		totalrecharge: 'การเติมเงินสะสม',
		totalwater: 'ยอดใช้จ่ายสะสม',
		waterratio: 'สัดส่วนการคืนน้ำ',
		jinji: 'อัพเกรด',
		lijin: 'ของขวัญ',
		level: 'เกรด',
		hot: 'ร้อน',
		live: 'คนจริง',
		slot: 'อิเล็กทรอนิกส์',
		chess: 'กระดานหมากรุก',
		sports: 'กีฬา',
		lottery: 'ลอตเตอรี่',
		fishing: 'ตกปลา',
		actrules: 'กฎกิจกรรม',
		accountlogin: 'หมายเลขบัญชี รหัสผ่าน เข้าสู่ระบบ',
		mobilelogin: 'เข้าสู่ระบบด่วนสำหรับโทรศัพท์',
		password: 'รหัสผ่าน',
		newpassword: 'รหัสผ่านใหม่',
		pleaseaccount: 'กรุณากรอกชื่อบัญชี',
		passtips: 'รหัสผ่านมีความยาว 6-15 ตัวอักษรต้องประกอบด้วยตัวอักษรและตัวเลข!',
		pleasepass: 'กรุณากรอกรหัสผ่าน',
		pleasetwcode: 'โปรดป้อนรหัสยืนยันข้อความ',
		country: 'ประเทศ / หมายเลขโทรศัพท์มือถือ',
		pleasemobile: 'กรุณากรอกหมายเลขโทรศัพท์มือถือ',
		yzm: 'รหัสยืนยัน',
		pleaseyzm: 'กรุณากรอกรหัสยืนยันโทรศัพท์มือถือ',
		sendcode: 'ส่งรหัสยืนยัน',
		currency: 'สกุลเงิน',
		usernametips: 'กรุณาใส่ตัวเลขภาษาอังกฤษ 4-16 หลัก',
		currencytips: 'กรุณาเลือกสกุลเงิน',
		againpass: 'ป้อนรหัสผ่านข้างต้นอีกครั้ง',
		ckmoney: 'จำนวนเงินฝาก',
		ckdate: 'วันที่ฝากเงิน',
		redmoney: 'จำนวนซองจดหมายสีแดง',
		activitycenter: 'กิจกรรม',
		lucrative: 'โปรโมชั่น',
		MemberManagement: 'การจัดการสมาชิก',
		CommissionSettlement: 'การชำระค่าคอมมิชชั่น',
		CommissionRecords: 'บันทึกค่าคอมมิชชั่น',
		FriendTransfer: 'โอนเงินให้เพื่อน',
		nightMode: 'โหมดดึก',
		Mobileauth: 'การรับรองโทรศัพท์มือถือ',
		Certified: 'ได้รับการรับรองแล้ว',
		nodata: 'ไม่มีข้อมูลแล้ว',
		Sportslive: 'กีฬาสด',
		MemberID: 'หมายเลขสมาชิก',
		MemberIDdesc: 'กรุณากรอกรหัสสมาชิก',
		friendID: 'รหัสเพื่อน',
		friendIDdesc: 'กรุณากรอกรหัสเพื่อนหรือหมายเลขโทรศัพท์มือถือ',
		findMember: 'คืนสมาชิก',
		Platformfees: 'ค่าธรรมเนียมแพลตฟอร์ม',
		PromotionalMaterials: 'โปรโมชั่นวัสดุ',
		copylink: 'คัดลอกที่อยู่เชื่อมโยง',
		SaveQRcode: 'บันทึกรหัส QR',
		interest: 'ความสนใจ',
		eliminate: 'กำจัด',
		Recommend: 'คำแนะนำ',
		new: 'ใหม่',
		searchfor: 'ค้นหา',
		searchfordesc: 'โปรดป้อนการค้นหา',
		find: 'ค้นหา',
		results: 'ผลลัพธ์',
		Cashier: 'เคาน์เตอร์ชำระเงิน',
		skip: 'ข้าม',
		Enterimmediately: 'เข้าไปเดี๋ยวนี้',
		APPlock: 'แอปพลิเคล็อค',
		actTime: 'ระยะเวลากิจกรรม',
		confirm: 'ระบุ',
		platformtype: 'ประเภทของแพลตฟอร์ม',
		orderState: 'สถานะการสั่งซื้อ',
		gameName: 'ชื่อเกม',
		gameNamedesc: 'กรุณาใส่ชื่อเกม',
		bettime: 'เวลาเดิมพัน',
		validamount: 'จำนวนเงินเดิมพัน',
		winloss: 'จำนวนเงินที่ชนะ',
		betnum: 'หมายเลขเกมเดียว',
		normal: 'ปกติ',
		abnormal: 'ไม่ปกติ',
		betTotal: 'จำนวนเงินเดิมพันทั้งหมด',
		winTotal: 'ยอดรวมที่ชนะ',
		Orderamount: 'จำนวนการสั่งซื้อ',
		Orderbet: 'ปริมาณการสั่งซื้อสินค้า',
		male: "ชาย",
		female: "ผู้หญิง",
		electron: "วิดีโอเกม",
		Dailyvideo: "วิดีโอแนะนำประจำวัน",
		Choicevideo: "แนะนำที่เลือก",
		videoList1: "อัพเดทล่าสุดทุกวัน",
		videoList2: "วิดีโอยอดนิยม",
		videoList3: "วิดีโอฟรี", //短視頻
		mydata1: "ภาพยนตร์และโทรทัศน์วีไอพีวันที่เหลือ",
		mydata2: "จำนวนเงินที่จะได้รับคืนน้ำ",
		waterAmount: "จำนวนเงินคืนของน้ำ",
		waterDate: "วันที่คืนน้ำ",
		noblet1: 'อัพเกรดวีไอพีทันที Full Station HD ดูไม่ จำกัด',
		noblet2: 'มาก่อนได้ก่อน รีบมาซื้อ',
		noblet3: 'ดูได้ไม่จำกัด,ของขวัญ',
		noblet4: 'ดูประวัติการซื้อ VIP',
		noblet5: 'คลิกที่นี่',
		order1: 'เวลา',
		Transamount: 'จำนวนเงินที่โอนได้',
		Dailylimit: 'จำกัดวันเดียว',
		vipIDdesc: 'กรุณาใส่รหัสสมาชิกหรือหมายเลขโทรศัพท์มือถือ',
		Transferaccount: 'โอนเข้าบัญชี',
		Transfermoney: 'จำนวนเงินที่โอน',
		Transfert1: 'หมายเหตุ: การเข้าร่วมแคมเปญข้อเสนอ ข้อจำกัดในการถอนจะไม่สามารถเข้าบัญชีได้',
		Transfert2: 'หมายเหตุ: หลังจากส่งสินค้าเรียบร้อยแล้วระบบจะเข้าบัญชีภายใน 10 นาทีหากไม่เข้าบัญชีโปรดติดต่อฝ่ายบริการลูกค้า',
		amount: 'จำนวนเงิน',
		receiptTime: 'เวลาบัญชี',
		Transferfriends: 'โอนย้ายเพื่อน',
		Transferringfriends: 'โอนไปยังเพื่อน',
		Descriptive: 'อธิบายข้อมูล',
		exchangerate: 'อัตราแลกเปลี่ยนแบบเรียลไทม์',
		Accountbalance: 'ยอดคงเหลือในบัญชี',
		withdrawal: 'ถอนเงินจำนวนรหัสที่ต้องการ',
		commission: 'ค่าธรรมเนียมการจัดการ',
		Exchangerate: 'การคำนวณอัตราแลกเปลี่ยน',
		illustrate: 'เคล็ดลับ',
		withdrawtilt1: 'การถอนเงินขั้นต่ำ 100 ครั้งหากไม่เข้าบัญชีโปรดติดต่อฝ่ายบริการลูกค้าออนไลน์',
		withdrawtilt2: 'บัตรธนาคารที่ถอนเงินต้องเป็นบัตรธนาคารของตัวเองมิฉะนั้นจะไม่สามารถเข้าบัญชีได้',
		tips: 'เคล็ดลับ',
		findvipt1: 'โดยคุณสมบัตินี้สามารถเรียกคืนสมาชิกระดับล่างที่ไม่มีการผูกมัดสำเร็จ',
		findvipt2: 'จำกัดจำนวนสมาชิกระดับล่างภายในระยะเวลาการลงทะเบียน 3 วัน',
		Totalplatformcost: 'ค่าธรรมเนียมแพลตฟอร์มทั้งหมด',
		Winlamount: 'จำนวนเงินที่แพ้และชนะ',
		PlatformRate: 'อัตราแพลตฟอร์ม',
		totalExpenses: 'ค่าใช้จ่ายทั้งหมด',
		commission1: 'อัตราส่วนค่าคอมมิชชั่นปัจจุบัน',
		commission2: 'อัตราส่วนค่าคอมมิชชั่น',
		Mycommission: 'คอมมิชชั่นของฉัน',
		totalRecharge: 'ยอดการเติมเงิน',
		totalWithdraw: 'จำนวนเงินถอน',
		totalPeople: 'จำนวนสมาชิก',
		activePeople: 'สมาชิกที่ใช้งาน',
		addPeople: 'เพิ่มเดือนนี้',
		SettlementDate: 'วันที่ชำระราคา',
		DayMonth: 'วัน / เดือน',
		ImmeSettle: 'การตั้งถิ่นฐานทันที',
		Formula: 'สูตรการคำนวณ',
		SettleMoney: 'ค่าคอมมิชชั่นที่ได้รับ',
		Date: 'วันที่',
		authname: 'ชื่อรับรอง',
		authnamedesc: 'กรุณากรอกชื่อผู้โอน',
		hashelp: 'หากต้องการความช่วยเหลือ',
		contact: 'ติดต่อฝ่ายบริการลูกค้า',
		Agreement: 'โปรโตคอล / สกุลเงิน',
		ckNumber: 'จำนวนฝาก',
		cbaddress: 'ที่อยู่เติมเงิน',
		notes: 'หมายเหตุ',
		Scancoins: 'สแกนคิวอาร์โค้ดเพื่อเติมเงิน',
		content: 'เนื้อหา',
		ckdesc: 'กรุณากรอกรายละเอียดการฝากเงิน',
		zfAccount: 'บัญชีการชำระเงิน',
		zfbank: 'ธนาคารชำระเงิน',
		banktype: 'ประเภทการเติมเงิน',
		banktypedesc: 'กรุณาเลือกประเภทการเติมเงิน',
		zzzh: 'โอนออกจากบัญชี',
		zjzh: 'โอนเข้าบัญชี',
		whole: 'ทั้งหมด',
		zzmoney: 'จำนวนเงินที่โอน',
		zhtime: 'เวลาโอน',
		zzpt: 'แพลตฟอร์มการโอนเงิน',
		Paymentmethod: 'วิธีการชำระเงิน',
		behalf: 'การชำระเงินสำหรับเพื่อน',
		saccountdesc: 'กรุณาเลือกบัญชีรับเงิน',
		cztips: 'กรุณาโอนเงินเข้าบัญชีข้างต้นเพื่อยื่นคำร้อง เจ้าหน้าที่จะดำเนินการให้ท่านในครั้งแรก',
		currency1: 'สกุลเงิน',
		exchangeRate1: 'อัตราแลกเปลี่ยน',
		Rebate: 'เงินคืน',
		Receive1: 'เติมเงินเข้าบัญชี',
		PaymentVoucher: 'อัพโหลดบัตรกำนัลการชำระเงิน',
		DepositTime: 'เวลาฝาก',
		DepositTimedesc: 'โปรดเลือกเวลาฝาก',
		BlockchainID: 'บล็อกเชนID',
		BlockchainIDdesc: 'โปรดป้อนรหัสบล็อกเชน',
		tradeID: 'รหัสธุรกรรมID 6 หลัก',
		tradeIDdesc: 'กรุณากรอกรหัสธุรกรรม 6 หลัก',
		withdraw1: 'ถอนเงินเข้าบัญชี',
		gamenoIndesc: 'ในการบำรุงรักษาเกมโปรดลองอีกครั้งในภายหลัง ~',
		cznamedesc1: 'เติมเงินออนไลน์ครั้งแรกต้องผูกชื่อจริง',
		cznamedesc2: 'โปรดตรวจสอบให้แน่ใจว่าชื่อนี้ตรงกับชื่อผู้ฝาก มิฉะนั้นจะไม่สามารถเข้าบัญชีได้',
		cznamedesc3: 'เมื่อส่งแล้วไม่สามารถเปลี่ยนแปลงได้ โปรดกรอกข้อมูลให้ละเอียดรอบคอบ',
		txnamedesc1: 'ผูกข้อมูลครั้งแรกต้องผูกชื่อจริง',
		txnamedesc2: 'โปรดตรวจสอบให้แน่ใจว่าชื่อนี้ตรงกับชื่อผู้ถอนเงิน มิฉะนั้นจะไม่สามารถเข้าบัญชีได้',
		txnamedesc3: 'เมื่อส่งแล้วไม่สามารถเปลี่ยนแปลงได้ โปรดกรอกข้อมูลให้ละเอียดรอบคอบ',
		modify: 'การปรับเปลี่ยน',
		inviteId: 'รหัสเชิญ',
		findpaypass: 'ค้นหารหัสผ่านการชำระเงิน',
		Movies: 'ภาพยนตร์และโทรทัศน์',
		rakeback: 'การคืนน้ำ',
		rescue: 'กู้ภัย',
		RedeemCode: 'แลกรหัส',
		dhTitle: 'บันทึกการแลกของฉัน',
		dhtxt: 'แลก',
		dhtxtbtn: 'แลกทันที',
		dhtxtdesc: 'ใส่รหัสแลก',
		dhmoney: 'จำนวนเงินที่แลกเปลี่ยน',
		dhlsbs: 'การไหลของน้ำ Multiple',
		lqtime: 'เวลารับ',
		free: 'ฟรี',
		zznamedesc1: 'ไม่มีค่าใช้จ่าย กรุณากรอกชื่อจริงของผู้โอน มิฉะนั้นจะไม่สามารถเข้าบัญชีได้โดยอัตโนมัติ',
		zznamedesc2: 'หากภายใน 10 นาทียอดเติมเงินไม่เข้าบัญชีโปรดติดต่อฝ่ายบริการลูกค้าออนไลน์',
		tgrs: 'จำนวนผู้แนะนำปัจจุบัน',
		tglink: 'ลิงค์แนะนำ',
		tgyqewm: 'เชิญ QR Code',
		wxts: 'เคล็ดลับที่อบอุ่น',
		tgtips1: 'สมัครชื่อโดเมนแยกต่างหาก กรุณาติดต่อเจ้าหน้าที่หน่วยงาน',
		tgtips2: 'หากคุณเป็นหัวหน้าสถานีและต้องการสื่อโฆษณาโปรดติดต่อฝ่ายบริการลูกค้า',
		tgtips3: 'เชิญเพื่อนมาลงทะเบียน เพียงให้เพื่อนกรอกรหัสเชิญตอนลงทะเบียน',
		mycenter: 'ศูนย์ส่วนบุคคล',
		myInfo: 'ข้อมูลส่วนบุคคล',
		mylucrative: 'คำแนะนำของฉัน',
		Security: 'ความปลอดภัยของบัญชี',
		timeframe: 'เวลา',
		starttime: 'เวลาเริ่มต้น',
		endtime: 'เวลาสิ้นสุด',
		Keysdesc: "กรุณาเลือกประเทศ",
		Keysdesc1: "กรุณาเลือกรหัสพื้นที่",
		rule1: 'มีอายุครบ 21 ปี และได้อ่านและยินยอม',
		rule2: '[กฎและข้อกำหนด]',
		autotrans:'โอนเงินอัตโนมัติ',
		autotranstips:'ยอดเงินจะถูกโอนไปยังบัญชีเกมที่เกี่ยวข้องโดยอัตโนมัติเมื่อเล่นเกม',
		handtrans:'โอนเงินด้วยตนเอง',
		handtranstips:'สำหรับการโอนเงินด้วยตนเองโปรดปิด [การโอนอัตโนมัติ]',
		jytype:'ประเภทการซื้อขาย',
		wechat:'วีแชท',
		Alipay:'อาลีเพย์',
		yjed:'ค่าคอมมิชชั่น',
		yjsed:'วงเงินที่ชำระแล้ว',
	},
	footer: {
		fkfs: 'วิธีการชำระเงิน',
		partners: 'พาร์ทเนอร์',
		followUs: 'ติดตามเรา',
		regauth: 'หน่วยงานกำกับดูแล',
		pagcor: 'PAGCOR',
		legalage: 'ถูกกฏหมาย อายุ',
		cs: 'ฝ่ายบริการลูกค้า',
		telegram: 'เครื่องบิน',
		network: 'เครือข่าย',
		dark: 'กลางคืน',
		byday: 'กลางวัน',
		affiliate: 'affiliate',
		TOP: 'ด้านบน',
		chat: 'แชท',
	},
	home: {
		hotgametit: "เกมยอดนิยม",
		activitydesc1: "Tengda ซุปเปอร์มารยาท",
		activitydesc2: "เรียกเพื่อน Cai Jin Qiqi ได้รับ",
		new: "ล่าสุด",
		Chesscardsdesc1: "กระดานหมากรุกสากล",
		Chesscardsdesc2: "ประสบการณ์การเล่นเกมที่สมจริง，",
		Chesscardsdesc3: "ปัญญาประดิษฐ์ที่สมจริง,",
		Chesscardsdesc4: "ความหลากหลายของโหมดและวิธีการเล่นใหม่",
		Chesscardsdesc5: "เกมหมากรุกระดับไฮเอนด์แพลตฟอร์มที่ร้อนแรงสุด ..",
		lotterydesc1: "ลอตเตอรี่",
		lotterydesc2: "ด้วยเกมลอตเตอรี่คลาสสิกและนวัตกรรม",
		lotterydesc3: "ซึ่งจะเพิ่มกระบวนการเล่นของความปรารถนา",
		onsitedesc1: "LIVE CASINO",
		onsitedesc2: "ยึดมั่นในแนวคิด'บริการสูงสุด'เรามุ่งมั่นที่จะให้บริการแก่ผู้เล่นที่เป็นสมาชิกในวงกว้าง",
		onsitedesc3: "เกมพนันออนไลน์ที่มีมากที่สุด และระบบบริการที่หลากหลายและมีมูลค่าสูง",
		placeholderdesc: "กรุณาใส่ชื่อเกม",
		gogamebtn: "เข้าสู่เกม",
		swgamebtn: "เกมทดลองเล่น",
		swbtn: "ทดลองเล่น",
		egamesdesc1: "ซอฟต์แวร์เกมปาล์ม",
		egamesdesc2: "ผู้ให้บริการวิดีโอเกมชั้นนำระดับโลก",
		egamesdesc3: "ส่วนใหญ่พัฒนาวิดีโอเกมทั้งออฟไลน์และออนไลน์",
		egamesdesc4: "ด้วยเมืองบันเทิงที่ใหญ่ที่สุดในเอเชีย",
		livedesc1: "Casino Live",
		livedesc2: "AG ALLBET  OG DS ",
		livedesc3: "แพลตฟอร์มความบันเทิงยอดนิยม",
		livedesc4: "เสือมังกร, ดอกไม้ทองทอด, จานสี, แผงลอยและโต๊ะเล่นอื่น ๆ Ren Jun เลือก,",
		livedesc5: "มอบประสบการณ์หรูหราที่ดื่มด่ำ!",
		sportdesc1:"กีฬา",
		sportdesc2:"ประเภทของการเดิมพันส่วนใหญ่ประสบการณ์การเดิมพันที่แข็งแกร่งที่สุด",
		sportdesc3:"รองรับการถอนเงินออกล่วงหน้า",
		sportdesc4:"เก็บข้าวได้รวดเร็วอีกก้าว คิดในใจ",
		sportdesc5:"เลือกคนที่ชอบ",
		fishdesc1:"ตกปลา",
		fishdesc2:"ตกปลาบ้า! ระเบิดสูงพิเศษ",
		fishdesc3:"อัตรา สมบัติมหาศาลกำลังรอคุณอยู่!",
		tiptitle: 'คำเตือนที่สำคัญ',
		tipclose: 'ปิด',
		tipflag: 'ไม่เตือนวันนี้',
		testdesc1: "เว็บไซต์ทางการล่าสุด",
		testdesc2: "เคล็ดลับที่อบอุ่น: URL ที่มีค่า MS ต่ำสุดจะเปิดได้เร็วขึ้น!",
		LinkTimeout: "หมดเวลาการเชื่อมโยง",
		GoImmediately: "เดินทางทันที",
		Recheck: "ตรวจสอบความเร็วในการเข้าถึงอีกครั้ง",
		Enter:'เข้า',
	},
	help: {
		title0: 'เกี่ยวกับเรา',
		title1: 'คำถามที่พบบ่อย',
		title2: 'นโยบายความเป็นส่วนตัว',
		title3: 'การปฏิเสธความรับผิดชอบ',
		title4: 'ติดต่อเรา',
		title5: 'ตัวแทนแฟรนไชส์',
		title6: 'ความรับผิดชอบต่อการเดิมพัน',
		title7: 'ความร่วมมือทางธุรกิจ',
		service: 'ฝ่ายบริการลูกค้าออนไลน์',
		servicedesc: 'สะดวก รวดเร็ว ทันเวลา',
	},
	download: {
		scantxt: 'สแกน QR Code เพื่อดาวน์โหลด APP',
		downtext: "ดาวน์โหลด APP",
		downdesc: "เปิดบัญชี TDBET วันนี้และเพลิดเพลินไปกับโบนัสที่ดีที่สุด!",
		version: "รุ่น",
		ScanCodedown: "สแกนโค้ดดาวน์โหลด APP",
		BeCurrent: "วัตถุประสงค์ทั่วไป",
		H5org: "เข้าชมหน้า H5",
	},
	vip: {
		viptitle1: "เทศกาลพีค",
		viptitle2: "Glory ล่องเรือ",
		viptitle3: "เข้าร่วม TENDA VIP เพื่อรับบริการสูงสุด",
		vipen: "BECOME A VIP MEMBER AND ENJOY THE MOST HONORBLE SERVICE",
		totalDeposit: "การเติมเงินสะสม",
		totalBet: "น้ำไหลสะสม",
		vipBLdesc: "สัดส่วนการคืนเงินวีไอพี",
		vipgradetitle: "ระดับวีไอพี",
		vipgrade1: "คนจริง",
		vipgrade2: "อิเล็กทรอนิกส์",
		vipgrade3: "กระดานหมากรุก",
		vipgrade4: "กีฬา",
		vipgrade5: "ลอตเตอรี่",
		vipgrade6: "อีสปอร์ต รีเทิร์น",
		ActivityRules: "กฎกิจกรรม",
		Rulestext1: "หลักเกณฑ์การส่งเสริมการขาย",
		Rulesdesc1: "ยอดเงินฝากสะสมของสมาชิก รวมทั้งยอดเงินฝากสะสมของสมาชิกถึงระดับที่กำหนด จะสามารถเลื่อนระดับวีไอพีได้ภายในเวลา 24.00 น. ของวันถัดไป",
		Rulestext2: "ลำดับโปรโมชั่น",
		Rulesdesc2: "สามารถเลื่อนระดับวีไอพีได้ถึงระดับที่กำหนดในแต่ละวัน แต่ไม่สามารถเลื่อนระดับวีไอพีได้",
		Rulestext3: "ข้อกำหนดการรับประกัน",
		Rulesdesc3: "สมาชิกจะต้องทำการเดิมพันให้ครบถ้วนภายในระยะเวลา 90 วัน หลังจากถึงเลเวลวีไอพีที่กำหนด หากการเลื่อนตำแหน่งสำเร็จภายในระยะเวลาดังกล่าว ผู้ค้ำประกันจะต้องคำนวณตามระดับปัจจุบันอีกครั้ง",
		Rulestext4: "เกณฑ์การปรับลด",
		Rulesdesc4: "หากสมาชิกไม่เสร็จสิ้นข้อกําหนดการรับประกันภัยที่สอดคล้องกันภายในหนึ่งไตรมาส (คํานวณ 90 วัน) ระบบจะลดระดับลงหนึ่งระดับโดยอัตโนมัติและการคืนน้ําที่สอดคล้องกันและสิทธิพิเศษอื่น ๆ จะถูกปรับเป็นระดับหลังจากลดระดับด้วย",
		Rulestext5: "โบนัสอัพเกรด",
		Rulesdesc5: "โบนัสการอัพเกรดจะถูกแจกโดยอัตโนมัติเมื่อสมาชิกถึงระดับสมาชิกแล้ว โบนัสการอัพเกรดแต่ละระดับจะได้รับเพียง 1 ครั้งต่อสมาชิก (ของขวัญการอัพเกรดสามารถถอนได้ 1 เท่า)",
		Rulestext6: "ของขวัญวันเกิด",
		Rulesdesc6: "สมาชิกมีวันเกิดภายในสามเดือนของการลงทะเบียนและไม่สามารถรับของขวัญวันเกิดในปีนี้ สมาชิกที่ลงทะเบียนเกิน 3 เดือน สามารถรับบัตรได้ที่หน้า VIP ในวันเกิดของท่าน และรับบัตรปีละ 1 ครั้ง (ของขวัญวันเกิด 1x น้ำไหลสามารถถอนได้)",
		Rulestext7: "ซองจดหมายสีแดงรายเดือน",
		Rulesdesc7: "สมาชิกมีประวัติการฝากเงินสำเร็จอย่างน้อย 1 ครั้งในเดือนที่แล้ว สามารถไปที่หน้า VIP เพื่อรับ 1/2 ของจำนวนเงินซองจดหมายสีแดงรายเดือนในระดับที่สอดคล้องกันของวันที่ 1 และ 16 ตามลำดับ (ของขวัญซองจดหมายสีแดง 1 เท่าสามารถถอนได้)",
		Rulestext8: "Tengda Entertainment Entertainment Entertainment ขอสงวนสิทธิ์ในการแก้ไขกิจกรรม หยุดและอธิบายขั้นสุดท้าย",
		Rulesdesc8: "หมายเหตุ: ยอดเงินคืนสูงสุดสำหรับแต่ละสถานที่จัดงาน และจำนวนเงินคืนที่แน่นอนขึ้นอยู่กับเกมจริง และจะทยอยออกในวันถัดไป เวลา 15.00 - 16.00 น.",

	},
}


// WEBPACK FOOTER //
// ./src/lang/thai.js